// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1025px) and (max-width: 1372px) {

  .offerings {
    width: 33.333333% !important;
  }
}

@media (min-width: 1373px) {

  .offerings {
    width: 33.333333% !important;
  }
}

.offerings_lists {
  list-style: disc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/doyenAccess/components/offerings/doyenAccessOfferings.css"],"names":[],"mappings":"AACE;;EAAA;IAAA;EAAmC;AAAA;;AAAnC;;EAAA;IAAA;EAAmC;AAAA;;AAGrC;EACE,gBAAgB;AAClB","sourcesContent":[".offerings {\n  @apply lg:w-1/3 xl:w-1/3 !important;\n}\n\n.offerings_lists {\n  list-style: disc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
